export default __webpack_public_path__ + "9b7c1b6888fcc2fd86af09b1db9a2a8b.png";